<ng-container *ngIf="vm$ | async as vm">
    <div *ngIf="vm.state === 'loading'" class="myc-loading" data-testid="myc-loading">
        <div class="myc-loading__spinner" aria-label="loading"></div>
    </div>

    <div *ngIf="vm.state === 'error'" class="myc-error" data-testid="myc-error">
        {{ 'aumico_analytics_load_failed_message' | i18next }}
    </div>

    <empty-state-view
        *ngIf="vm.state === 'empty'"
        (createProject)="onCreateProject()">
    </empty-state-view>

    <normal-state-view
        *ngIf="vm.state === 'normal' && vm.harmonized && vm.controls"
        [harmonized]="vm.harmonized"
        [controls]="vm.controls"
        [currencies]="vm.currencies"
        [isAllExpanded]="vm.isAllExpanded"
        [exportInFlight]="vm.exportInFlight"
        (yearToggled)="onYearToggled($event)"
        (deltaModeChanged)="onDeltaModeChanged($event)"
        (reportScopeChanged)="onReportScopeChanged($event)"
        (structModeToggled)="onStructModeToggled()"
        (nodeToggled)="onNodeToggled($event)"
        (showAllDetails)="onShowAllDetails()"
        (hideAllDetails)="onHideAllDetails()"
        (exportPdf)="onExportPdf()"
        (languageChanged)="onLanguageChanged($event)">
    </normal-state-view>
</ng-container>
